(function () {
  if (window.EmuScrollIntroLoaded) return;
  window.EmuScrollIntroLoaded = true;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function ease(value) {
    return value * value * (3 - 2 * value);
  }

  function findSlideshowTarget() {
    return document.querySelector('#MainContent slideshow-component, main slideshow-component');
  }

  function initScrollIntro() {
    var intros = Array.from(document.querySelectorAll('[data-emu-scroll-intro]'));
    if (!intros.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var target = findSlideshowTarget();

    if (target) {
      target.classList.add('emu-scroll-intro-target');
    }

    var ticking = false;

    function update() {
      ticking = false;

      intros.forEach(function (intro) {
        if (reduceMotion.matches) {
          intro.style.setProperty('--emu-scroll-copy-opacity', '1');
          intro.style.setProperty('--emu-scroll-copy-y', '0px');
          intro.style.setProperty('--emu-scroll-copy-blur', '0px');
          if (target) target.style.setProperty('--emu-home-slideshow-scale', '1');
          return;
        }

        var rect = intro.getBoundingClientRect();
        var distance = Math.max(180, intro.offsetHeight * 0.85);
        var progress = clamp(-rect.top / distance, 0, 1);
        var eased = ease(progress);

        intro.style.setProperty('--emu-scroll-copy-opacity', (1 - eased).toFixed(3));
        intro.style.setProperty('--emu-scroll-copy-y', (-76 * eased).toFixed(1) + 'px');
        intro.style.setProperty('--emu-scroll-copy-blur', (1.4 * eased).toFixed(2) + 'px');
        intro.classList.toggle('is-scrolled', progress > 0.02);

        if (target) {
          target.style.setProperty('--emu-home-slideshow-scale', (1 + 0.1 * eased).toFixed(4));
        }
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    reduceMotion.addEventListener('change', requestUpdate);
    requestUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollIntro);
  } else {
    initScrollIntro();
  }

  document.addEventListener('shopify:section:load', initScrollIntro);
})();
